(function () {
  'use strict';

  /* =========================================
     MOBILE MENU
  ========================================= */

  var toggle = document.getElementById('elxMenuToggle');
  var menu = document.getElementById('elxMobileMenu');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* =========================================
     REAL SHOPIFY CART COUNT
     Initial quantity is rendered by Liquid.
     We only request /cart.js after cart changes or
     when a page is restored from the back/forward cache.
  ========================================= */

  var cartRequest = null;

  function elxUpdateCartCount() {
    if (cartRequest) return cartRequest;

    cartRequest = fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart could not be loaded');
        return response.json();
      })
      .then(function (cart) {
        var counter = document.getElementById('elxCartCount');
        if (!counter) return;

        var quantity = Number(cart.item_count || 0);
        counter.textContent = quantity;
        counter.classList.toggle('is-zero', quantity <= 0);
      })
      .catch(function () {
        /* Keep the server-rendered count if the request fails. */
      })
      .finally(function () {
        cartRequest = null;
      });

    return cartRequest;
  }

  document.addEventListener('cart:updated', elxUpdateCartCount);
  document.addEventListener('cart:refresh', elxUpdateCartCount);
  document.addEventListener('cart:change', elxUpdateCartCount);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) elxUpdateCartCount();
  });
})();
